import {useEffect, useState} from 'react'

/* Track scroll position to drive edge-aware arrow visibility. Returns
 * `atStart` / `atEnd` so the arrow render can hide the leading / trailing
 * button when there's nothing to scroll to. With infinite-loop on, the
 * caller ignores these flags and keeps both arrows visible. */
export const useEdgeState = (scrollRef, {enabled, slidesLength}) => {
    const [atStart, setAtStart] = useState(true)
    const [atEnd, setAtEnd] = useState(false)

    useEffect(() => {
        if (!enabled) return undefined
        const node = scrollRef.current
        if (!node) return undefined
        const update = () => {
            const {scrollLeft, scrollWidth, clientWidth} = node
            setAtStart(scrollLeft <= 1)
            setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1)
        }
        update()
        node.addEventListener('scroll', update, {passive: true})
        const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update)
        if (ro) ro.observe(node)
        return () => {
            node.removeEventListener('scroll', update)
            if (ro) ro.disconnect()
        }
    }, [enabled, slidesLength, scrollRef])

    return {atStart, atEnd}
}
